<ng-container *ngIf="cardBloc.detailViewCard$ | async as cardData">
  <kui-modal
    class="detail-card"
    *ngIf="cardData?.detailViewClicked"
    [isOpen]="cardData?.detailViewClicked"
    (isOpenChange)="closeDetailModal(cardData)">
    <kp-detail-card-view
      [card]="cardData?.card"
      [screen]="cardData?.screen"
      [quest]="cardData?.quest"
      [questItem]="cardData?.questItem"
      [requestType]="cardData?.requestType"
      (modalClose)="closeDetailModal(cardData, $event)"></kp-detail-card-view>
  </kui-modal>
</ng-container>

<ng-container *ngIf="localResourcesCardBloc.detailViewCard$ | async as cardData">
  <kui-modal
    class="detail-card"
    *ngIf="cardData?.detailViewClicked"
    [isOpen]="cardData?.detailViewClicked"
    (isOpenChange)="closeDetailModal(cardData)"
    [reverseClose]="true">
    <kp-local-resources-card-detail-view
      [card]="cardData?.card"
      [source]="cardData?.source"
      [screen]="cardData.screen"
      [zipCode]="cardData.zip"
      (modalClose)="closeDetailModal(cardData)"></kp-local-resources-card-detail-view>
  </kui-modal>
</ng-container>

<kui-modal *ngIf="firstCardModalOpen" [isOpen]="firstCardModalOpen">
  <kp-first-card-added [cardType]="cardType" (closeClicked)="closeFirstCardModal()"></kp-first-card-added>
</kui-modal>

<kui-modal
  *ngIf="(socialChallengeBloc.showCelebrationModal$ | async) && (tagBloc.socialChallengeEnabled$ | async)"
  [isOpen]="socialChallengeBloc.showCelebrationModal$ | async"
  (isOpenChange)="socialChallengeBloc.closeCelebrationModal()">
  <kf-sc-modal-social-challenge-celebrate></kf-sc-modal-social-challenge-celebrate>
</kui-modal>

<a class="skip-to-content-link" [href]="skipLinkPath">Skip to Main Content</a>

<ng-container *ngIf="pastReflectionsBloc.pastReflectionViewClicked$ | async as pastReflectionViewClicked">
  <kui-modal
    *ngIf="pastReflectionViewClicked"
    [isOpen]="pastReflectionViewClicked"
    (isOpenChange)="closeDetailModal()"
    labelValue=""
    describedById="pastReflectionsTitle date">
    <kp-reflection-history (closeClicked)="closeDetailModal()"></kp-reflection-history>
  </kui-modal>
</ng-container>

<ng-container *ngIf="(versionBloc.appVersionMeetsMinimum$ | async) === false as failsMinimum">
  <kui-modal
    *ngIf="failsMinimum"
    [isOpen]="failsMinimum"
    [canDismiss]="false"
    [contentFlex]="true"
    labelValue=""
    describedById="">
    <kui-version-expired
      [product]="environmentVariablesService.product"
      [productName]="productName"></kui-version-expired>
  </kui-modal>
</ng-container>

<kp-account-creation-banner
  *ngIf="globalElementsService.showAccountCreationBanner$ | async"></kp-account-creation-banner>

<kp-site-header
  *ngIf="globalElementsService.showHeader$ | async"
  [navActive]="navActive"
  (navBtnClick)="navBtnClicked()"
  [quickActionsOpen]="quickActionsEnabled"
  (quickActionsToggled)="quickActionsToggled($event)"></kp-site-header>
<kp-site-basic-logo-header
  class="hidden-print"
  [ngClass]="{ banner: globalElementsService.showAccountCreationBanner$ | async }"
  *ngIf="globalElementsService.showBasicLogoHeader$ | async"></kp-site-basic-logo-header>
<section
  class="main"
  [ngClass]="{
    'no-chrome':
      (globalElementsService.showChrome$ | async) === false &&
      (globalElementsService.showBasicLogoHeader$ | async) === false,
    'no-header':
      (globalElementsService.showHeader$ | async) === false &&
      (globalElementsService.showBasicLogoHeader$ | async) === false,
    'no-nav': (globalElementsService.showNav$ | async) === false,
    'overlap-header': (globalElementsService.showBasicLogoHeader$ | async) === true
  }">
  <div class="overlay" *ngIf="quickActionsEnabled" (click)="closeOverlay()"></div>
  <kp-site-nav
    class="hidden-print"
    *ngIf="(globalElementsService.showChrome$ | async) && (globalElementsService.showNav$ | async)"
    [navActive]="navActive"
    (sidebarClick)="sidebarClicked($event)"></kp-site-nav>
  <kp-live-support class="hidden-print" *ngIf="globalElementsService.showLiveSupport$ | async"></kp-live-support>
  <main class="content" id="main">
    <router-outlet></router-outlet>
    <ng-container
      *ngIf="{
        showPhotoModal: imageBloc.showPhotoModal$ | async,
        photoModalDetails: imageBloc.photoModalDetails$ | async
      } as photoModalData">
      <kui-modal
        *ngIf="photoModalData.showPhotoModal"
        [isOpen]="photoModalData.showPhotoModal"
        (isOpenChange)="imageBloc.closePhotoModal()"
        type="photo">
        <kp-photo-carousel
          [selectedImageId]="photoModalData.photoModalDetails.selectedImageId"
          [initialImageType]="
            photoModalData.photoModalDetails.image ? photoModalData.photoModalDetails.currentImageType : null
          "
          [allImages]="(imageBloc.imageStatus$(photoModalData.photoModalDetails.carouselImagesType) | async)?.data"
          (closeModal)="imageBloc.closePhotoModal()"></kp-photo-carousel>
      </kui-modal>
    </ng-container>
  </main>
</section>
<kp-site-footer
  *ngIf="(globalElementsService.showChrome$ | async) && (globalElementsService.showHeader$ | async)"
  [navActive]="navActive"
  (navBtnClick)="navBtnClicked()"
  [quickActionsOpen]="quickActionsEnabled"
  (quickActionsToggled)="quickActionsToggled($event)"></kp-site-footer>
<kp-version-tag [hidden]="true"></kp-version-tag>
